(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const initialized = new WeakSet();
  let mutationFrame = 0;

  function createDots(host, scroller, items, options = {}) {
    if (!mobileQuery.matches || !host || !scroller || items.length < 2 || initialized.has(host)) return;
    initialized.add(host);

    const dots = document.createElement('div');
    dots.className = `rl-mobile-dots${options.light ? ' rl-mobile-dots--light' : ''}`;
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', options.label || 'Navigazione carosello');

    const buttons = items.map((item, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `Vai alla scheda ${index + 1} di ${items.length}`);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      button.addEventListener('click', () => {
        const style = getComputedStyle(scroller);
        const paddingLeft = parseFloat(style.paddingLeft) || 0;
        const left = Math.max(0, item.offsetLeft - paddingLeft);
        scroller.scrollTo({ left, behavior: 'smooth' });
      });
      dots.appendChild(button);
      return button;
    });

    host.insertAdjacentElement('afterend', dots);

    let ticking = false;
    const update = () => {
      ticking = false;
      const viewportCenter = scroller.scrollLeft + scroller.clientWidth / 2;
      let activeIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const distance = Math.abs(itemCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      buttons.forEach((button, index) => {
        button.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    scroller.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestAnimationFrame(update);
  }

  function initSelectedTrees() {
    document.querySelectorAll('.rl-st-grid').forEach((grid) => {
      const cards = [...grid.querySelectorAll('.rl-st-card')];
      createDots(grid, grid, cards, { label: 'Alberi selezionati' });
    });
  }

  function initServices() {
    document.querySelectorAll('.rl-canopy__grid').forEach((grid) => {
      const cards = [...grid.querySelectorAll('.rl-canopy-card')];
      createDots(grid, grid, cards, { label: 'Servizi' });
    });
  }

  function initRecommendations() {
    document.querySelectorAll('product-recommendations slideshow-component.resource-list__carousel').forEach((slideshow) => {
      const scroller = slideshow.querySelector('slideshow-slides');
      const slides = scroller ? [...scroller.querySelectorAll('slideshow-slide.resource-list__slide')] : [];
      const host = slideshow.parentElement;
      createDots(host, scroller, slides, { label: 'Altri alberi selezionati' });
    });
  }

  function initJournalSocial() {
    document.querySelectorAll('.rl-journal-social__grid').forEach((grid) => {
      const cards = [...grid.querySelectorAll('.rl-journal-social__tile')];
      createDots(grid, grid, cards, { label: 'Dal vivaio' });
    });
  }

  function syncMenuLock() {
    const hasOpenMenu = mobileQuery.matches && Boolean(document.querySelector('details.rl-mobile-nav[open]'));
    document.documentElement.classList.toggle('rl-mobile-menu-open', hasOpenMenu);
  }

  function initMobileMenu() {
    document.querySelectorAll('details.rl-mobile-nav').forEach((menu) => {
      if (menu.dataset.rlMobileMenuReady === 'true') return;
      menu.dataset.rlMobileMenuReady = 'true';

      menu.addEventListener('toggle', syncMenuLock);
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          menu.querySelector('summary')?.focus();
        }
      });
    });
    syncMenuLock();
  }

  function init() {
    if (!mobileQuery.matches) {
      document.documentElement.classList.remove('rl-mobile-menu-open');
      return;
    }
    initSelectedTrees();
    initServices();
    initRecommendations();
    initJournalSocial();
    initMobileMenu();
  }

  function scheduleInit() {
    cancelAnimationFrame(mutationFrame);
    mutationFrame = requestAnimationFrame(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scheduleInit);
  mobileQuery.addEventListener?.('change', scheduleInit);

  const observer = new MutationObserver(scheduleInit);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
